import type { ProvidersState } from './ProvidersState';

export default {
  setProviders(state: ProvidersState, providers: string[]): void {
    state.providersNames = providers;
  }
};
